import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

const fontsPath = '//assets1.prezicdn.net/common/fonts/';

export const GlobalStylesReset = createGlobalStyle`
  ${normalize}

  body * {
    box-sizing: border-box;
  }

  body {
    font-family: ${({ theme }) => theme.bento.font.primary.family};
  }
`;

export const FontFaceDefinitions = createGlobalStyle`
  @font-face {
    font-family: 'Raleway';
    src: url(${`${fontsPath}raleway-regular.woff`}) format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Raleway';
    src: url(${`${fontsPath}raleway-medium.woff`}) format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Raleway';
    src: url(${`${fontsPath}raleway-semibold.woff`}) format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Raleway';
    src: url(${`${fontsPath}raleway-bold.woff`}) format('woff');
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Raleway';
    src: url(${`${fontsPath}raleway-heavy.woff`}) format('woff');
    font-weight: 800;
    font-style: normal;
    font-display: fallback;
  }
`;

export const LegacyFontFaceDefinitions = createGlobalStyle`
  @font-face {
    font-family: 'RalewayRegular';
    src: url(${`${fontsPath}raleway-regular.woff`}) format('woff');
    font-display: fallback;
  }
  @font-face {
    font-family: 'RalewayMedium';
    src: url(${`${fontsPath}raleway-medium.woff`}) format('woff');
    font-display: fallback;
  }
  @font-face {
    font-family: 'RalewaySemiBold';
    src: url(${`${fontsPath}raleway-semibold.woff`}) format('woff');
    font-display: fallback;
  }
  @font-face {
    font-family: 'RalewayBold';
    src: url(${`${fontsPath}raleway-bold.woff`}) format('woff');
    font-display: fallback;
  }
  @font-face {
    font-family: 'RalewayHeavy';
    src: url(${`${fontsPath}raleway-heavy.woff`}) format('woff');
    font-display: fallback;
  }
`;
